<template>
    <div>
        <PageTitle title="INSCRIPCIÓN A CANTERA" class="strech" />
        <section>
            <b-container class="mt-4">
                <Stepper 
                    :steps="steps"
                    ref="stepper"
                >
                    <template #paso1="{ changeStep }">
                        <PasoUnoComponent 
                            :esMovil="esMovil"
                            :base="base" 
                            :codigo_invitacion="codigo_invitacion" 
                            :fields="fields.filter(field => field.pivot.deportista === true)"
                            @setNewStep="((categoria) => { addNewStep(categoria) })"
                            @terminado="(data) => { actualizarBase(data); addNewStep(data['categoria_base']); changeStep(); }"
                        />
                    </template>
            
                    <template #paso2="{ changeStep }">
                        <PasoDosComponent 
                            :esMovil="esMovil" 
                            :base="base"  
                            :fields="fields.filter(field => field.pivot.representante === true)"
                            @terminado="(data) => { actualizarBase(data); changeStep(); }" 
                            @volver="() => { changeStep(true); }"
                        />
                    </template>
            
                    <template #paso3="{ changeStep }">
                        <PasoTresComponent 
                            :esMovil="esMovil" 
                            :base="base" 
                            @terminado="(data) => { actualizarBase(data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>
            
                    <template #paso4="{ changeStep }">
                        <PasoCuatroComponent 
                            :esMovil="esMovil" 
                            :base="base" 
                            @terminado="(data) => { actualizarBase(data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>
            
                    <template #paso5="{ changeStep }">
                        <PasoCincoComponent 
                            v-if="base.categoria_base.tiene_indumentarias"
                            :esMovil="esMovil" 
                            :base="base" 
                            @terminado="(indumentarias, data) => { terminarPasoCinco(indumentarias, data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>
            
                    <template #paso6="{ changeStep }">
                        <PasoSeisComponent 
                            :esMovil="esMovil" 
                            :base="base" 
                            :paso_activo="!pago_paycomet" 
                            @terminado="(data) => { actualizarBase(data); changeStep() }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>
                    <template #pago>
                        <ProcesarCompraComponent :base="base" />
                    </template>
                </Stepper>
            </b-container>
        </section>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import PasoUnoComponent from "@/components/frontend/bases/PasoUnoComponent";
    import PasoDosComponent from "@/components/frontend/bases/PasoDosComponent";
    import PasoTresComponent from "@/components/frontend/bases/PasoTresComponent";
    import PasoCuatroComponent from "@/components/frontend/bases/PasoCuatroComponent";
    import PasoCincoComponent from "@/components/frontend/bases/PasoCincoComponent";
    import PasoSeisComponent from "@/components/frontend/bases/PasoSeisComponent";
    import ProcesarCompraComponent from "@/components/frontend/bases/ProcesarCompraComponent";
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        data() {
            return {
                base: {
                    nacionalidad: "Española",
                    filters: {},
                    fields_deportista: {},
                    fields_responsable_1: {},
                    fields_responsable_2: {}
                },
                pago_paycomet: false,
                codigo_invitacion: null,
                esMovil: false,
                tieneIndumentarias: false
            };
        },
        created() {
            useHead('Cantera');
            if(!this.manager.futbol_base || this.manager.activar_compra_por_invitacion_bases && localStorage.getItem('codigo_invitacion') == null) {
                this.$router.push({ name: 'front.home'});
            }
            this.base.filters.tid = this.configuracion.hash_teatro;
            if (this.manager.activar_compra_por_invitacion_bases) {
                this.codigo_invitacion  = localStorage.getItem('codigo_invitacion');
                localStorage.removeItem('codigo_invitacion');
            }
            if (this.teatro.tipo_tpv === 2) {
                this.steps.push({ label: "Datos de pago", slot: "pago" });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            fields() {
                return this.$store.getters.getListaAbonados.fields_deportistas;
            },
            steps() {
                const steps = [
                    { label: this.$t('bases.datos_deportista'), slot: 'paso1' },
                    { label: this.$t('bases.datos_responsables'), slot: 'paso2' },
                    { label: this.$t('bases.documentacion'), slot: 'paso3' },
                    { label: this.$t('bases.foto_de_perfil'), slot: 'paso4' },
                ];

                if (this.tieneIndumentarias) {
                    steps.push({ label: this.$t('bases.indumentarias'), slot: 'paso5' });
                }

                steps.push({ label: this.$t('bases.resumen_compra'), slot: 'paso6' });
                
                if (this.teatro?.tipo_tpv === 2) {
                    steps.push({ label: this.$t('bases.pago'), slot: 'pago' });
                }

                return steps;
            }
        },
        methods: {
            actualizarBase(data) {
                this.base = { ...data };
            },
            terminarPasoCinco(indumentariasElegidas, data) {
                if (indumentariasElegidas) {
                    this.base.categoria_base.indumentariasElegidas = indumentariasElegidas;
                }

                this.actualizarBase(data);
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            },
            addNewStep(categoria) {
                this.tieneIndumentarias = !!categoria?.tiene_indumentarias;
            },
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        components: {
            PageTitle,
            PasoUnoComponent,
            PasoDosComponent,
            PasoTresComponent,
            PasoCuatroComponent,
            PasoCincoComponent,
            PasoSeisComponent,
            ProcesarCompraComponent,
            Stepper
        },
    };
</script>